import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import mountainVillage from '../assets/image/mountain_village.png';
import '../styles/AdminLogin.css';

const AdminLogin = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    
    // Validation des champs obligatoires
    if (!username.trim()) {
      setError('Le nom d\'utilisateur est obligatoire.');
      return;
    }
    
    if (!password.trim()) {
      setError('Le mot de passe est obligatoire.');
      return;
    }
    
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000/api'}/token/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username, password }),
      });

      if (response.ok) {
        const data = await response.json();
        localStorage.setItem('access_token', data.access);
        localStorage.setItem('refresh_token', data.refresh);
        // Sauvegarde du nom d'utilisateur et des permissions
        localStorage.setItem('username', data.username);
        localStorage.setItem('is_superadmin', data.is_superadmin);
        localStorage.setItem('can_manage_partners', data.can_manage_partners);
        localStorage.setItem('can_manage_members', data.can_manage_members);
        localStorage.setItem('can_manage_events', data.can_manage_events);
        localStorage.setItem('can_manage_products', data.can_manage_products);
        localStorage.setItem('can_manage_projects', data.can_manage_projects);
        localStorage.setItem('can_manage_reservations', data.can_manage_reservations);
        navigate('/admin/dashboard');
      } else {
        setError('Identifiants incorrects. Veuillez réessayer.');
      }
    } catch (err) {
      setError('Impossible de se connecter au serveur.');
    }
  };

  return (
    <div className="login-page-container">
      <div className="login-card">
        {/* Left Section: Visuals */}
        <div className="login-visual-side" style={{ backgroundImage: `url(${mountainVillage})` }}>
          <div className="visual-overlay"></div>
          <button className="back-to-site" onClick={() => navigate('/')}>
            ← Retour au site
          </button>
          
          <div className="visual-content">
            <h1 className="visual-logo">TI<span>WIZI</span></h1>
            <p className="visual-description">
              Interface de gestion administrative centralisée et sécurisée.
            </p>
          </div>
        </div>

        {/* Right Section: Form */}
        <div className="login-form-side">
          <div className="form-header">
            <h2>Connexion</h2>
            <p>Bienvenue dans votre espace d'administration.</p>
          </div>

          <form onSubmit={handleLogin} className="login-actual-form">
            {error && <div className="login-error-alert">{error}</div>}
            
            <div className="login-input-group">
              <label>UTILISATEUR <span className="required-star">*</span></label>
              <input 
                type="text" 
                value={username} 
                onChange={(e) => setUsername(e.target.value)} 
                placeholder="Votre identifiant"
                required
              />
            </div>

            <div className="login-input-group">
              <label>MOT DE PASSE <span className="required-star">*</span></label>
              <div className="password-wrapper">
                <input 
                  type={showPassword ? 'text' : 'password'} 
                  value={password} 
                  onChange={(e) => setPassword(e.target.value)} 
                  placeholder="********"
                  required
                />
                <button
                  type="button"
                  className="password-toggle-btn"
                  onClick={() => setShowPassword(!showPassword)}
                  aria-label={showPassword ? 'Masquer le mot de passe' : 'Afficher le mot de passe'}
                >
                  {showPassword ? (
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/>
                      <line x1="1" y1="1" x2="23" y2="23"/>
                    </svg>
                  ) : (
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/>
                    </svg>
                  )}
                </button>
              </div>
            </div>

            <button type="submit" className="login-submit-btn">
              Se connecter
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
